import { render, staticRenderFns } from "./MudarInstituicao.vue?vue&type=template&id=489c3c52&"
import script from "./MudarInstituicao.vue?vue&type=script&lang=js&"
export * from "./MudarInstituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports